import { render, staticRenderFns } from "./MSAConfig.vue?vue&type=template&id=126ca36f"
import script from "./MSAConfig.vue?vue&type=script&lang=js"
export * from "./MSAConfig.vue?vue&type=script&lang=js"
import style0 from "./MSAConfig.vue?vue&type=style&index=0&id=126ca36f&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VBtnToggle,VIcon,VMenu,VTooltip})
